var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center_col_container"},[_c('BackgroundHeader',{attrs:{"text":"上课流程"}}),_c('LessonProcessDisplay')],1)}
var staticRenderFns = []

export { render, staticRenderFns }